import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { OrganizationConfig } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/organization-config/model';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit {
    @Input() data: OrganizationConfig;

    ngOnInit(): void {
        const schema = JSON.parse(JSON.stringify(this.baseline.schema));

        const value = schema.properties?.AuditDisabled?.const;

        if (value !== undefined) {
            this.control.setValue(value);
        } else {
            this.control.setValue('any');
        }

        this.control.valueChanges.subscribe((value) => {
            if (value === 'any') {
                delete schema.properties?.AuditDisabled?.const;
                schema.required = [];
            } else {
                schema.properties.AuditDisabled['const'] = value;
                schema.required = ['AuditDisabled'];
            }

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(schema)),
            });
        });
    }
}
